import FormValidator from './validation';
import FormHandler from './handler';

document.addEventListener('DOMContentLoaded', () => {
  const formClass = '.js-validate';
  const forms = document.querySelectorAll(formClass);

  forms.forEach((formElement) => {
    new FormValidator(formClass, {
      onSubmit: async (event) => {
        event.preventDefault();

        const formHandler = new FormHandler(formElement);

        formHandler.handleSubmission(event);
      },
    });
  });
});
